import type { ReactNode } from "react";
import { VariantGrid, VariantItem } from "./playgroundControls";

const FieldStage = ({ children }: { children: ReactNode }) => (
    <div style={{ width: 220 }}>{children}</div>
);

interface StateCells {
    normal: ReactNode;
    optional: ReactNode;
    tip: ReactNode;
    error: ReactNode;
    disabled: ReactNode;
}

/** One kit field in its normal, optional, tip, error and disabled states. */
export const StateRow = ({
    title,
    cells,
}: {
    title: string;
    cells: StateCells;
}) => (
    <VariantGrid title={title} columns="wide">
        {Object.entries(cells).map(([state, cell]) => (
            <VariantItem key={state} label={state}>
                <FieldStage>{cell}</FieldStage>
            </VariantItem>
        ))}
    </VariantGrid>
);

export const TIP = "Shown on the check stub";
